import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CardTitle } from "@postcheesy/ui-lib/molecules";
import { useUser } from "../../resources/contexts/UserContext";
import { ROUTES } from "../../resources/constants/routes";
import { LogoutButton } from "./LogoutButton";

export const LogoWithLogout: React.FC = () => {
    const location = useLocation();
    const { isActive } = useUser();

    const isSetupFlow = [
        ROUTES.CONFIRM_EMAIL,
        ROUTES.VERIFY_PHONE,
        ROUTES.PROFILE_SETUP
    ].includes(location.pathname as ROUTES);

    if (isSetupFlow && !isActive) {
        return (
            <div className="flex items-center gap-4">
                <LogoutButton variant="link">
                    <CardTitle className="text-background serif">Espace Gourmand</CardTitle>
                </LogoutButton>
            </div>
        );
    }

    return (
        <Link to={isActive ? "/dashboard" : '/'} className={location.pathname === "/" ? "disabled" : ""}>
            <CardTitle className="text-background serif">Espace Gourmand</CardTitle>
        </Link>
    );
}; 